const DELIVERY_SERVICE_NAMES_BY_CODE = {
  0: "Нова пошта",
  1: "Укр. пошта",
};

const DELIVERY_SERVICE_CODES_BY_ID = {
  "1bf61851-347c-4d0d-a62e-d488dce9c0da": "0",
  "2bf61851-347c-4d0d-a62e-d488dce9c0da": "1",
};

export function getDeliveryServiceName(deliveryService) {
  const code = deliveryService?.code ?? DELIVERY_SERVICE_CODES_BY_ID[deliveryService?.id];
  return DELIVERY_SERVICE_NAMES_BY_CODE[code] ?? deliveryService?.name ?? "";
}

export function localizeDeliveryServices(deliveryServices) {
  return deliveryServices.map((deliveryService) => ({
    ...deliveryService,
    name: getDeliveryServiceName(deliveryService),
  }));
}
